import React, { ReactNode } from 'react';
import { Card } from 'antd';
import { Table } from 'antd';
import Loading from '../Loading';
import Text from '../Text';
import isEmpty from 'lodash/isEmpty';
import './DataTableCard.less';

import type { TablePaginationConfig } from 'antd/lib/table';

type RowKeyFunction = (record) => string;

export type DataTableCardProps = {
  title: string;
  seeAllLink?: ReactNode;
  height?: string;
  loading?: boolean;
  fallback?: ReactNode;
  children?: ReactNode;
  data?: {}[];
  columns?: {}[];
  pagination?: false | TablePaginationConfig;
  seeMoreLink?: ReactNode;
  noPadding?: Boolean;
  rowKey?: string | RowKeyFunction;
  cursorPointer?: Boolean;
  onItemClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onRowClick?: (event: any) => void;
};

const TDataTableCard: React.FC<DataTableCardProps> = ({
  title,
  seeAllLink,
  height,
  data,
  columns,
  pagination,
  seeMoreLink,
  fallback,
  loading = false,
  noPadding,
  rowKey = 'id',
  cursorPointer,
  onRowClick = () => {},
  onItemClick = () => {},
}) => {
  const classnames = [cursorPointer && 't-data-table-card-cursor-pointer'];
  return (
    <div className="t-dataTableCard-container" onClick={onItemClick}>
      <div className="t-card-title">
        <Text rows={1} level={1} bold>
          {title}
        </Text>
        {seeAllLink && (
          <Text level={3} textColor="dark-20">
            {seeAllLink}
          </Text>
        )}
      </div>
      <Card
        style={{ height: height || 'auto' }}
        bodyStyle={{ padding: noPadding ? '0' : '16px' }}
      >
        <>
          {loading ? (
            <Loading />
          ) : !isEmpty(data) ? (
            <Table
              rowKey={rowKey}
              className={classnames.join(' ')}
              pagination={pagination}
              dataSource={data}
              columns={columns}
              onRow={(record) => {
                return {
                  onClick: () => onRowClick(record),
                };
              }}
            />
          ) : (
            <div className="t-card-fallback">{fallback}</div>
          )}
        </>
      </Card>
      <div className="t-card-table-footer">{seeMoreLink}</div>
    </div>
  );
};

export default TDataTableCard;
